// extracted by mini-css-extract-plugin
export var modal = "_um-0";
export var table = "_um-1";